import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import classnames from 'classnames';

import {Link} from 'shells/link/link';

import {colors} from '../../colors/colors';

import type {Tab as TabProps} from './icon-tabs';

import styles from './icon-tabs.module.css';

export function IconTab(props: TabProps) {
    const {Icon} = props;
    const iconColor = props.isActive ? colors.blue : colors.grey;

    const tabContent = (
        <Icon
            color={iconColor}
            className='flex justify-center align-center full-width full-height'
            size={props.size ? props.size : 20}
        />
    );

    const tabStyle = classnames(styles['view-tab'], {
        [styles['view-tab-active']]: props.isActive,
    });

    return (
        <div data-tip={props.label} className={tabStyle}>
            {props.href ? (
                <Link
                    // @ts-expect-error
                    as={RoutedLink}
                    variant='secondary'
                    to={props.href}
                    preventUnderline={true}
                    className='flex full-width full-height justify-center align-center'
                >
                    {tabContent}
                </Link>
            ) : (
                <button
                    onClick={props.onClick}
                    className='no-padding flex full-width full-height justify-center align-center'
                >
                    {tabContent}
                </button>
            )}
        </div>
    );
}
